// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"55":"d3a1af04","106":"fc88b1d3"}[chunkId] + ".chunk.css";
};